module.exports = __webpack_public_path__ + "img/global-samsung-logo.48a69515.svg";